import Mock from 'mockjs'
import cache from '../../common/cache'

// mock开关
let mock = cache.getSessionData('mock')
let mockSwitch = mock === 1 ? '' : '_'

// 网站定制接口
Mock.mock(/store_config/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'group_config': {
      'group_id': 99,
      'group_name': '广汇集团',
      'identifier': 'sec',
      'msg_signature': 'dos测试集团',
      'short_name': '',
      'is_zs_group': true
    },
    // 用户当前登录的门店
    'store_config': {
      'store_id': 99,
      'store_name': 'dos测试4s店(养车通)',
      'is_zs_store|1': true,
      'ins_work_flow_upgraded': true
    },
    // 用户关联的门店
    'stores_config': [{
      'store_id': 99,
      'store_name': 'dos测试4s店(养车通)',
      'is_zs_store|1': true,
      'ins_work_flow_upgraded': true
    }, {
      'store_id': 98,
      'store_name': 'dos测试4s店(养车通)',
      'is_zs_store|1': true,
      'ins_work_flow_upgraded': true
    }]
  },
  'message': 'ok'
})
